import { Controller } from '@hotwired/stimulus'
import { turboFrame, current } from '../helpers'
import { formsProjectMessageBoardsPath } from '../routes'

const MESSAGE_BOARDS_FRAME_ID = 'forms_message_boards'

export default class extends Controller {
  static values = { formId: String }

  selectDestination ({ detail: { projectId, target } }) {
    if (target !== 'message_board') return
    this.removeMessageBoards()
    if (projectId) this.insertMessageBoardsFrame(projectId)
  }

  // Private

  insertMessageBoardsFrame (projectId) {
    const messageBoardsFrame = turboFrame(
      MESSAGE_BOARDS_FRAME_ID,
      formsProjectMessageBoardsPath(current.account.id, projectId, { form_id: this.formIdValue }),
      { class: 'block' }
    )
    this.element.appendChild(messageBoardsFrame)
  }

  removeMessageBoards () {
    document.getElementById(MESSAGE_BOARDS_FRAME_ID)?.remove()
  }
}
